import React from 'react';

export const User = (props) => {
  return (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.103 15.754C19.369 15.754 22.1406 12.8109 22.1406 9.00306C22.1406 5.28624 19.354 2.43416 16.103 2.43416C12.8371 2.43416 10.0355 5.33176 10.0505 9.0334C10.0505 12.8109 12.8221 15.754 16.103 15.754ZM6.7546 29.8627H25.4215C27.8934 29.8627 28.7474 29.1042 28.7474 27.7085C28.7474 23.8096 23.8634 18.4392 16.0881 18.4392C8.32765 18.4392 3.42871 23.8096 3.42871 27.7085C3.42871 29.1042 4.28265 29.8627 6.7546 29.8627Z" />
    </svg>
  );
};
